module.exports = __webpack_public_path__ + "static/media/cups.b7b0c6c7.svg";